import { defineRecipe } from '@chakra-ui/react';

export const linkRecipe = defineRecipe({
  variants: {
    variant: {
      underline: {
        color: 'colorPalette.fg',
        textDecoration: 'underline',
        textUnderlineOffset: '3px',
        textDecorationColor: 'currentColor/20',
        _hover: {
          fontWeight: 'medium'
        }
      }
    }
  },

  defaultVariants: {
    variant: 'underline'
  }
});
